import Vue from "vue";
import VueRouter from "vue-router";

const Home = () => import("../views/Home.vue");

const Login = () => import("../views/Login.vue");
const Signup = () => import("../views/Signup.vue");
const ForgotPassword = () => import("../views/forgot-password/ForgotPassword.vue");
const Profile = () => import("../views/Profile.vue");

const RegisterDesktop = () => import("../views/register-desktop/RegisterDesktop.vue");

const PageNotFound = () => import("../views/PageNotFound.vue");

// Catalogs
const Catalogs = () => import("../views/catalogs/Catalogs.vue");
const ResolutionsCatalogs = () =>
  import("../views/catalogs/resolutions-catalogs/ResolutionsCatalogs.vue");
const CreateResolutionsCatalog = () =>
  import("../views/catalogs/resolutions-catalogs/CreateResolutionsCatalog.vue");
const EditResolutionsCatalog = () =>
  import("../views/catalogs/resolutions-catalogs/EditResolutionsCatalog.vue");
const Buildings = () => import("../views/catalogs/buildings/Buildings.vue");
const CreateBuilding = () => import("../views/catalogs/buildings/CreateBuilding.vue");
const EditBuilding = () => import("../views/catalogs/buildings/EditBuilding.vue");
const Majorities = () => import("../views/catalogs/majorities/Majorities.vue");
const CreateMajority = () => import("../views/catalogs/majorities/CreateMajority.vue");
const EditMajority = () => import("../views/catalogs/majorities/EditMajority.vue");
// Meetings
const Meetings = () => import("../views/meetings/Meetings.vue");
const CreateMeeting = () => import("../views/meetings/CreateMeeting.vue");
const EditMeeting = () => import("../views/meetings/EditMeeting.vue");
const Meeting = () => import("../views/meetings/Meeting.vue");
const MeetingCorrespondence = () => import("../views/meetings/MeetingCorrespondence.vue");
const MeetingAgenda = () => import("../views/meetings/MeetingAgenda.vue");
const MeetingDocuments = () => import("../views/meetings/MeetingDocuments.vue");
const MeetingPresence = () => import("../views/meetings/MeetingPresence.vue");
const MeetingStart = () => import("../views/meetings/MeetingStart.vue");
const MeetingRegister = () => import("../views/meetings/MeetingRegister.vue");
// Configurations
const Configurations = () => import("../views/configurations/Configurations.vue");
const LegalMentions = () =>
  import("../views/configurations/configuration-settings/LegalMentions.vue");
const PdfConfiguration = () =>
  import("../views/configurations/configuration-settings/PdfConfiguration.vue");
const AgencyLre = () => import("../views/configurations/configuration-settings/AgencyLre.vue");

Vue.use(VueRouter);

// TODO: FIXME: needs changes to work on desktop also
// NOTE: check if authenticated
import store from "@/store/store";
const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters["auth/isAuthenticated"]) {
    next();
    return;
  }
  next({ name: "home" });
};
const ifAuthenticated = (to, from, next) => {
  if (store.getters["auth/isAuthenticated"]) {
    next();
    return;
  }
  next({ name: "login" });
};

const routes = [
  {
    path: "/",
    redirect: { name: "home" },
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/home",
    name: "home",
    component: Home,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/About.vue"),
    beforeEnter: ifAuthenticated,
  },
  /** Profile */
  {
    path: "/profile",
    name: "profile",
    component: Profile,
    beforeEnter: ifAuthenticated,
  },
  /** Auth */
  {
    path: "/login",
    name: "login",
    component: Login,
    beforeEnter: ifNotAuthenticated,
  },
  {
    path: "/signup",
    name: "signup",
    component: Signup,
    beforeEnter: ifNotAuthenticated,
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: ForgotPassword,
    beforeEnter: ifNotAuthenticated,
  },
  {
    path: "/register-desktop",
    name: "register-desktop",
    component: RegisterDesktop,
    // beforeEnter: ..., FIXME: ???: ..
  },
  /** Catalogs */
  {
    path: "/catalogs",
    redirect: { name: "buildings" },
    name: "catalogs",
    component: Catalogs,
    beforeEnter: ifAuthenticated,
    children: [
      {
        path: "resolutions-catalogs",
        name: "resolutions-catalogs",
        component: ResolutionsCatalogs,
        children: [
          {
            path: "create", // ???: create automatically in the database then use created id? "create/:id"
            name: "create-resolutions-catalog",
            component: CreateResolutionsCatalog,
          },
          {
            path: "edit/:id",
            name: "edit-resolutions-catalog",
            component: EditResolutionsCatalog,
          },
        ],
      },
      {
        path: "buildings",
        name: "buildings",
        component: Buildings,
        children: [
          {
            path: "create", // ???:
            name: "create-building",
            component: CreateBuilding,
          },
          {
            path: "asl/create",
            name: "create-building-asl",
            component: CreateBuilding,
          },
          {
            path: "edit/:id",
            name: "edit-building",
            component: EditBuilding,
          },
          {
            path: "asl/edit/:id",
            name: "edit-building-asl",
            component: EditBuilding,
          },
        ],
      },
      {
        path: "majorities",
        name: "majorities",
        component: Majorities,
        children: [
          {
            path: "create", // ???:
            name: "create-majority",
            component: CreateMajority,
          },
          {
            path: "edit/:id",
            name: "edit-majority",
            component: EditMajority,
          },
        ],
      },
    ],
  },
  /** Meetings */
  {
    path: "/meetings",
    name: "meetings",
    component: Meetings,
    beforeEnter: ifAuthenticated,
    children: [
      {
        path: "create",
        name: "create-meeting",
        component: CreateMeeting,
      },
      {
        path: ":id/edit",
        name: "edit-meeting",
        component: EditMeeting,
      },
      {
        path: ":id",
        redirect: { name: "meetings" },
        name: "meeting",
        component: Meeting,
        children: [
          {
            path: "correspondence",
            name: "meeting-correspondence",
            component: MeetingCorrespondence,
          },
          {
            path: "agenda",
            name: "meeting-agenda",
            component: MeetingAgenda,
          },
          {
            path: "presence",
            name: "meeting-presence",
            component: MeetingPresence,
          },
          {
            path: "start",
            name: "meeting-start",
            component: MeetingStart,
          },
          {
            path: "documents",
            name: "meeting-documents",
            component: MeetingDocuments,
          },
        ],
      },
    ],
  },
  /** Meeting register */
  {
    path: "/meeting/register/:id",
    name: "meeting-register",
    component: MeetingRegister,
  },
  /** Configs */
  {
    path: "/configurations",
    redirect: { name: "configurations-legal-mentions" },
    name: "configurations",
    component: Configurations,
    beforeEnter: ifAuthenticated,
    children: [
      {
        path: "legal-mentions",
        name: "configurations-legal-mentions",
        component: LegalMentions,
      },
      {
        path: "pdf",
        name: "configurations-pdf",
        component: PdfConfiguration,
      },
      {
        path: "agency-lre",
        name: "configurations-agency-lre",
        component: AgencyLre,
      },
    ],
  },
  /** Page not found */
  {
    path: "*",
    name: "404",
    component: PageNotFound,
  },
];

var router = undefined;

if (!process.env.VUE_APP_IS_WEB) {
  router = new VueRouter({
    // INFO: history mode on desktop is not working
    base: process.env.BASE_URL,
    routes,
  });
} else {
  router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
  });
}

export default router;
